import { ArrowLeftIcon } from '@components/Icons/ArrowLeftIcon';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import css from './BackToLogin.module.scss';

export const BackToLogin = () => {
  return (
    <Box className={css.container}>
      <Link to="/login" className={css.backToLoginLink}>
        <ArrowLeftIcon /> Back to login
      </Link>
    </Box>
  );
};
